import React from 'react'
import classNames from 'classnames'

type Props = {
  label: string
  icon: string
  badge?: string
  textFirst?: boolean
  iconText?: string
  badgeType?: string
  classes?: {
    label?: string
    icon?: string
    badge?: string
  }
}

const IconWithText: React.FC<Props> = ({
  label,
  icon,
  badge,
  textFirst = false,
  iconText = ' ',
  badgeType = 'info',

  classes = {
    label: 'text-link',
    icon: '',
    badge: ''
  }
}) => {
  const isUsingFontAwesome = icon.startsWith('fa')

  return (
    <>
      {
        textFirst && (
          <span className={classes.label}>
            { label }
          </span>
        )
      }
      {
        isUsingFontAwesome
          ? <><i className={classNames('fas', icon, classes.icon)}>{ ' ' }</i> { iconText }</>
          : <img src={icon} alt={label} />
      }
      {
        !textFirst && (
          <span className={classes.label}>
            { label }
          </span>
        )
      }
      {
        !!badge && (
          <span className={classNames('badge', `badge-${badgeType}`, classes.badge)}>
            { badge }
          </span>
        )
      }
    </>
  )
}

export default IconWithText
